<template>
  <BaseCard class="seo-block shadow" :full-bleed="true">
    <div class="flex flex-col items-center justify-center p-6">
      <figure class="image mb-3 mt-2">
        <FontAwesomeIcon :icon="icon" class="text-primary icon w-10 h-10" />
      </figure>
      <TypeHeading
        :variant="$options.Typography.Heading.TITLE"
        :weight="$options.Typography.Weights.STRONG"
        class="text-primary text-center mb-2"
      >
        <p style="min-height: 43px">{{ heading }}</p>
      </TypeHeading>
      <BaseButton :to="slug" variant="primary" flat @click="$router.push(slug)"
        >Learn More</BaseButton
      >
    </div>
  </BaseCard>
</template>

<script>
import { BaseButton, BaseCard, TypeHeading, constants } from '@bambeehr/pollen';
import { defineComponent } from '@nuxtjs/composition-api';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheeseburger,
  faStore,
  faTv,
  faHeartbeat,
  faMemory,
  faGraduationCap,
  faHotel,
  faShieldAlt,
  faHospitalUser,
  faUserShield,
  faIndustry,
  faHeadset,
  faLightbulbOn,
  faHardHat,
  faGlobeAmericas,
  faChessClock,
  faFireExtinguisher,
  faMoneyBill,
  faUmbrella,
  faMedal,
  faHandHoldingUsd,
  faBaby,
  faHandPointRight,
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const { Typography } = constants;
library.add(faCheeseburger);
library.add(faStore);
library.add(faTv);
library.add(faHeartbeat);
library.add(faMemory);
library.add(faGraduationCap);
library.add(faHotel);
library.add(faShieldAlt);
library.add(faHospitalUser);
library.add(faUserShield);
library.add(faIndustry);
library.add(faHeadset);
library.add(faLightbulbOn);
library.add(faHardHat);
library.add(faGlobeAmericas);
library.add(faChessClock);
library.add(faFireExtinguisher);
library.add(faMoneyBill);
library.add(faUmbrella);
library.add(faMedal);
library.add(faHandHoldingUsd);
library.add(faBaby);
library.add(faHandPointRight);

export default defineComponent({
  name: 'SeoBlock',
  Typography,
  components: { BaseButton, BaseCard, FontAwesomeIcon, TypeHeading },
  props: {
    icon: {
      type: Array,
      required: true,
    },
    image: {
      type: String,
      default: '',
    },
    heading: {
      type: String,
      default: '',
    },
    slug: {
      type: String,
      default: '',
    },
  },
});
</script>

<style scoped>
.seo-block {
  max-width: 300px;
}
.seo-image {
  margin: 0 auto;
  margin-bottom: 1rem;
}
.seo-image path {
  fill: #481d72;
  stroke: #481d72;
}
</style>
